import { HookNavContext, HookNavGet } from 'Hook'
import { TypeNav, TypeNavHttpControl, TypeNavKey } from 'Type'

const HookNavContextNav = <T>(key :TypeNavKey, nav? :TypeNav<any>) :TypeNavHttpControl<T> => {
    return HookNavGet<T>({linkTo: HookNavContext(key, nav)})
}

export default HookNavContextNav